import axios from "axios";
import { serverApi } from "../../../config/Keys";
import {
  CLEAR_ERRORS,
  CLEAR_LOADER,
  SET_LOADER,
  SET_PROMOTIONAL_VIDEOS,
} from "../../types";
import { setErrors } from "../errorActions";
import Alert from "react-s-alert";

/********************************
 * @DESC ROLE MANAGEMENT SUPER ADMIN
 *******************************/

export const admin_promo_videos_add =
  (token, formData, onSuccess) => async (dispatch) => {
    console.log(token, formData);
    try {
      dispatch({ type: CLEAR_ERRORS });
      let response = await axios.post(
        `${serverApi}/promotions-Video`,
        formData,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (response.status === 201) {
        onSuccess();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_promo_videos_edit =
  (video_id, token, formData, onSuccess) => async (dispatch) => {
    console.log(token, formData);
    try {
      dispatch({ type: CLEAR_ERRORS });
      let response = await axios.patch(
        `${serverApi}/promotions-Video/${video_id}`,
        formData,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (response.status === 200) {
        if (onSuccess) onSuccess();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_promo_videos_get = (token) => async (dispatch) => {
  try {
    dispatch({ type: SET_LOADER });
    dispatch({ type: CLEAR_ERRORS });
    let response = await axios.get(`${serverApi}/promotions-Video`, {
      headers: {
        Authorization: token,
      },
    });
    if (response.status === 200) {
      dispatch({ type: SET_PROMOTIONAL_VIDEOS, payload: response.data });
      dispatch({ type: CLEAR_LOADER });
    }
  } catch (err) {
    Alert.error(
      `<h4>${err?.response?.data || "Please enter correct details."}</h4>`,
      {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 5000,
        offset: 35,
      }
    );
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

export const admin_video_patch =
  (token, video_id, changed_status, onSuccess) => async (dispatch) => {
    try {
      dispatch({ type: CLEAR_ERRORS });
      let response = await axios.patch(
        `${serverApi}/promotions-Video/${video_id}`,
        changed_status,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (response.status === 200) {
        if (onSuccess) onSuccess();
        Alert.success(`<h4> Updated succesfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 5000,
          offset: 35,
        });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_delete_role =
  (token, video_id, onSuccess) => async (dispatch) => {
    try {
      dispatch({ type: CLEAR_ERRORS });
      let response = await axios.delete(
        `${serverApi}/promotions-Video/${video_id}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (response.status === 200) {
        if (onSuccess) onSuccess();
        dispatch(admin_promo_videos_get(token));
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };
